var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._b({},'v-sheet',_vm.$attrs,false),[_vm._t("default"),_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.handleFileSelect}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }